import { ISendEmailPayload, ISendEmailSuccessResponse } from '@types';
import axios from './axios';

// eslint-disable-next-line import/prefer-default-export
export const postSendEmail = (data: ISendEmailPayload): Promise<ISendEmailSuccessResponse> =>
  axios.post<ISendEmailSuccessResponse>('/default/schedule-demo', data).then((res) => res.data);
